<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a class="ui_close" type="button" @click="$emit('close')"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.POPUP.SEARCH.MODEL') }}</i>
                    </dt>
                    <dd>
                        <div class="srchModal_wrap select_set2">
                            <dl class="dl_search">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p" v-model="searchKey">
                                        <option value="modelCode">{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</option>
                                        <option value="modelName">{{ $t('FIELD.GLOBAL.MODEL.NAME') }}</option>
                                        <option value="marketingName">{{ $t('FIELD.GLOBAL.MARKETINGNAME') }}</option>
                                    </select>
                                </dd>
                                <dd class="clearable" data-input-type="input">
                                    <input
                                        type="text"
                                        class="text_input w100p"
                                        v-model="searchName"
                                        placeholder="Enter search keyword , model code , marketing name"
                                        @keyup.enter.stop="onSearch()"
                                        v-clearable
                                    />
                                </dd>
                                <dd class="btn">
                                    <a class="btn_srch" @click="onSearch()">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                                </dd>
                            </dl>
                        </div>

                        <div class="grid_wrap mt-10">
                            <toast-grid
                                :gridId="gridId"
                                :columns="columns"
                                :data="gridData"
                                :options="options"
                                :ref="gridId"
                                :key="gridKey"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                                :click="contentClick"
                            />
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.APPLY') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import ToastGrid from '~c/ToastGrid';

// Toast Grid Custom Renderer
class CustomButtonRenderer {
    //check
    // constructor(props) {
    //     // <label class="checkbox-wrap"><input type="checkbox" name="" value=""><i class="check-icon"></i></label>
    //     const el = document.createElement('label');
    //     el.classList.add('checkbox-wrap');

    //     const subel = document.createElement('input');
    //     subel.setAttribute('type', 'checkbox');
    //     subel.setAttribute('name', 'radio');

    //     const subel1 = document.createElement('i');
    //     subel1.classList.add('check-icon');

    //     el.appendChild(subel);
    //     el.appendChild(subel1);

    //     this.el = el;
    // }

    //radio
    constructor(props) {
        // <label class="radiobox-wrap "><input type="radio"><i class="radio-icon"></i></label>
        const el = document.createElement('label');
        el.classList.add('radiobox-wrap');

        const subel = document.createElement('input');
        subel.setAttribute('type', 'radio');
        subel.setAttribute('name', 'radio');

        const subel1 = document.createElement('i');
        subel1.classList.add('radio-icon');

        el.appendChild(subel);
        el.appendChild(subel1);

        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

// function addData(name, value) {

//     var elem = document.createElement("input");

//     elem.setAttribute("type", "hidden");
//     elem.setAttribute("name", name);
//     elem.setAttribute("value", value);

//     return elem;
// }

export default {
    name: 'searchModelPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        searchModel: {
            type: String,
            default: '',
        },
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'searchModelPopup',
            modelCd: '',
            modelNm: '',
            searchKey: 'modelCode',
            searchName: this.searchModel,
            category1Code: '',
            category2Code: '',
            category3Code: '',
            gridKey: 0,
            gridId: 'searchModelPopupGrid',
            columns: [
                {
                    header: '',
                    name: '',
                    align: 'center',
                    width: 40,
                    resizable: true,
                    sortable: false,
                    renderer: { type: CustomButtonRenderer },
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'CDMODEL',
                    align: 'center',
                    width: 180,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'),
                    name: 'NMMODEL',
                    align: 'center',
                    width: 220,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'),
                    name: 'MAKETNM',
                    align: 'center',
                    // width: 200,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 265,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: Number(localStorage.getItem('listRows')),
            },
        };
    },
    methods: {
        async onSearch() {
            if (SDLUtil.textLength(this.searchName) < 3) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.TEXT.LENGTH.OVER').replace('{0}', '3'));
                return false;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/model/modelPopupSearch.skp`,
                    qs.stringify({ searchKey: this.searchKey, searchName: this.searchName }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            this.rtnFunc(this.modelCd, this.modelNm, this.category1Code, this.category2Code, this.category3Code);
            this.$emit('close');
        },
        contentClick(e, rowData, grid) {
            let curRowKey = e.rowKey;
            if (curRowKey > this.pageOptions.perPage) curRowKey = e.rowKey % this.pageOptions.perPage;

            if ($('input[name=radio]')[curRowKey].checked) {
                this.modelCd = rowData[e.rowKey]['CDMODEL'];
                this.modelNm = rowData[e.rowKey]['NMMODEL'];
                this.category1Code = rowData[e.rowKey]['PRD_CATEGORY_CD1'];
                this.category2Code = rowData[e.rowKey]['PRD_CATEGORY_CD2'];
                this.category3Code = rowData[e.rowKey]['PRD_CATEGORY_CD3'];
            }
            // console.log('contentClick',e.rowKey,curRowKey,$('.radio-icon')[curRowKey].checked,rowData[e.rowKey]['CDMODEL'],rowData[e.rowKey]['NMMODEL']);
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/searchModelPopup.vue